import { render } from "./PlantTypeEvaluations.vue?vue&type=template&id=472ab630"
import script from "./PlantTypeEvaluations.vue?vue&type=script&lang=js"
export * from "./PlantTypeEvaluations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__